// bao migrate skip
import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-number-box";
import "./../../bindings/bao-pager";
import "./../../bindings/bao-upload";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-toolbar2";
import "./../../factories/bao-dialog";
import "./../../factories/child-tab-view-model";
import myDialog from "./../dialogs/service-level-agreement-service-category-change-dialog";
import ServiceLevelAgreementServiceCategoryDialog from "./../dialogs/service-level-agreement-service-category-dialog";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import * as ko from "knockout";
import ChildTabViewModel from "./../../factories/child-tab-view-model";
class ServiceLevelAgreementServiceCategoryTabModel extends ChildTabViewModel {
    Bao = Bao;
    ServiceLevelAgreement: any;
    TabPage: TabPage;
    CompleteCheck() {
        return true;
    }
    ;
    RefreshInProgress = ko.observable(false);
    PageIndex = ko.observable(0);
    PageSize = ko.observable(10);
    TotalRows = ko.observable(0);
    Sorting = ko.observableArray();
    ServiceCategoryCollection = ko.observableArray([]);
    SelectedServiceCategoryRow = ko.observable({});
    _deleteMessage = Bao.Session.GetMessage("msgDeleteServiceLevelAgreementServiceCategory");
    constructor(tabPage: TabPage, parent) {
        super(tabPage, null);
        this.TabPage = tabPage;
        this.ServiceLevelAgreement = parent;
        this.PageIndex.subscribe(() => {
            this.RefreshGrid();
        });
        this.Sorting.subscribe(() => {
            this.RefreshGrid();
        });
        this.SelectedServiceCategoryRow.subscribe((newValue: any) => {
            if (this.SelectedServiceCategoryRow() == null) {
                this.enableDisableButton("EditServiceLevelAgreementServiceCategory", false);
                this.enableDisableButton("DeleteServiceLevelAgreementServiceCategory", false);
                this.enableDisableButton("ChangeServiceLevelAgreementServiceCategory", false);
            }
            else {
                this.enableDisableButton("EditServiceLevelAgreementServiceCategory", true);
                this.enableDisableButton("DeleteServiceLevelAgreementServiceCategory", true);
                //Check if the billing rhythm is "single"
                if (newValue != null && newValue.BillingRhythmId != "00000000-0000-0000-0000-000000000001") {
                    //It is not single: button is enabled
                    this.enableDisableButton("ChangeServiceLevelAgreementServiceCategory", true);
                }
                else {
                    //It is single: button is disabled
                    this.enableDisableButton("ChangeServiceLevelAgreementServiceCategory", false);
                }
            }
        });
    }
    toolbarClick = (item) => {
        switch (item.ActionKey()) {
            case "AddServiceLevelAgreementServiceCategory":
                this.ShowServiceLevelAgreementServiceCategoryDialog(this.ServiceLevelAgreement.ServiceLevelAgreementId(), null);
                break;
            case "EditServiceLevelAgreementServiceCategory":
                if (this.SelectedServiceCategoryRow() != null) {
                    this.EditServiceLevelAgreementServiceCategory(this.SelectedServiceCategoryRow());
                }
                break;
            case "DeleteServiceLevelAgreementServiceCategory":
                var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, this._deleteMessage, "yesno");
                yesNoDialog.DialogResult.subscribe((result) => {
                    if (result === true) {
                        this.DeleteServiceLevelAgreementServiceCategory(this.ServiceLevelAgreement.ServiceLevelAgreementId(), this.SelectedServiceCategoryRow()["ServiceLevelAgreementServiceCategoryId"]);
                    }
                });
                break;
            case "ChangeServiceLevelAgreementServiceCategory":
                this.ServiceLevelAgreementServiceCategoryChange(this.SelectedServiceCategoryRow());
                break;
        }
    };
    RefreshGrid() {
        this.TabPage.IsLoading(true);
        return Bao.post("ServiceLevelAgreementTab/GetServiceLevelAgreementServiceCategoryCollection", JSON.stringify({
            sessionTabId: this.ServiceLevelAgreement.TabPage.SessionTabId,
            serviceLevelAgreementId: this.ServiceLevelAgreement.ServiceLevelAgreementId(),
            pageIndex: this.PageIndex(),
            pageSize: this.PageSize(),
            sorting: this.Sorting()
        }), (searchResult) => {
            this.TabPage.IsLoading(false);
            this.SelectedServiceCategoryRow(null);
            this.TotalRows(0);
            this.ServiceCategoryCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                this.ServiceCategoryCollection(searchResult.Models);
                this.TotalRows(searchResult.TotalRows);
            }
        });
    }
    ;
    _msgCancel = Bao.Session.GetMessage("msgCancel");
    _msgOk = Bao.Session.GetMessage("msgOk");
    AddServiceLevelAgreementServiceCategory(model, serviceLevelAgreementId) {
        this.TabPage.IsLoading(true);
        let x = this.MinimizeServiceCategory(model);
        Bao.post("ServiceLevelAgreementTab/AddServiceLevelAgreementServiceCategory", JSON.stringify({
            sessionTabId: this.ServiceLevelAgreement.TabPage.SessionTabId,
            serviceCategoryModel: ko.map.toJS(x),
            serviceLevelAgreementId: serviceLevelAgreementId
        }), () => {
            this.ServiceLevelAgreement.TabPage.DirtyFlag(true);
            this.RefreshGrid();
        });
    }
    ;
    MinimizeServiceCategory(model) {
        let result = ko.map.toJS(model);
        delete result.Bao;
        delete result.SelectedServiceCategory;
        return result;
    }
    ;
    DeleteServiceLevelAgreementServiceCategory(serviceLevelAgreementId, serviceLevelAgreementServiceCategoryId) {
        this.RefreshInProgress(true);
        Bao.post("ServiceLevelAgreementTab/DeleteServiceLevelAgreementServiceCategory", JSON.stringify({
            sessionTabId: this.ServiceLevelAgreement.TabPage.SessionTabId,
            serviceLevelAgreementId: serviceLevelAgreementId,
            serviceLevelAgreementServiceCategoryId: serviceLevelAgreementServiceCategoryId
        }), () => {
            this.RefreshInProgress(false);
            this.ServiceLevelAgreement.TabPage.DirtyFlag(true);
            this.RefreshGrid();
        });
    }
    ;
    EditServiceLevelAgreementServiceCategory(item) {
        this.ShowServiceLevelAgreementServiceCategoryDialog(this.ServiceLevelAgreement.ServiceLevelAgreementId(), item.ServiceLevelAgreementServiceCategoryId);
    }
    ;
    ShowServiceLevelAgreementServiceCategoryDialog(serviceLevelAgreementId, serviceLevelAgreementServiceCategoryId) {
        let dialog = new ServiceLevelAgreementServiceCategoryDialog(this.TabPage, this);
        dialog.Show(serviceLevelAgreementId, serviceLevelAgreementServiceCategoryId);
        dialog.DialogResult.subscribe((dialogResult) => {
            if (dialogResult == "ok") {
                this.AddServiceLevelAgreementServiceCategory(dialog.DialogViewModel, this.ServiceLevelAgreement.ServiceLevelAgreementId());
            }
        });
    }
    ;
    ServiceLevelAgreementServiceCategoryChange(item) {
        this.ShowServiceLevelAgreementServiceCategoryChangeDialog(this.ServiceLevelAgreement.ServiceLevelAgreementId(), item.ServiceLevelAgreementServiceCategoryId);
    }
    ;
    ShowServiceLevelAgreementServiceCategoryChangeDialog(serviceLevelAgreementId, serviceLevelAgreementServiceCategoryId) {
        let dialog = new myDialog(this.TabPage, this);
        dialog.init().then(() => {
            dialog.Show(serviceLevelAgreementId, serviceLevelAgreementServiceCategoryId, this.ServiceLevelAgreement.ServiceLevelAgreementTypeName());
            dialog.DialogResult.subscribe((dialogResult) => {
                if (dialogResult == true) {
                    if (dialog.ChangeAllServices() == "0") {
                        //Ändere nur die, die den angegebenen Werten entsprechen
                        let message = Bao.Session.GetMessage("msgServiceLevelAgreementServiceCategory.ReallyChangeFilteredServices");
                        message.$deferred.then((result) => {
                            message(message().replace('{0}', dialog.Tarif().toString()).replace('{1}', this.SelectedServiceCategoryRow()["Price"])
                                .replace('{2}', dialog.Amount().toString()).replace('{3}', this.SelectedServiceCategoryRow()["Amount"])
                                .replace('{4}', dialog.Month().toString()).replace('{5}', dialog.Year().toString()));
                        });
                        let questionDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, message, "question");
                        questionDialog.DialogResult.subscribe((result) => {
                            if (result === true) {
                                Bao.post("ServiceLevelAgreementTab/Change", JSON.stringify({
                                    oldAmount: dialog.Amount(),
                                    oldPrice: dialog.Tarif(),
                                    newAmount: this.SelectedServiceCategoryRow()["Amount"],
                                    newPrice: this.SelectedServiceCategoryRow()["Price"],
                                    serviceCategoryId: this.SelectedServiceCategoryRow()["ServiceCategoryId"],
                                    serviceLevelAgreementId: this.ServiceLevelAgreement.ServiceLevelAgreementId(),
                                    month: dialog.Month(),
                                    year: dialog.Year(),
                                    changeAll: false
                                }), (result) => {
                                    if (result.Result == true) {
                                        new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgCompletedWithSuccess"), "info");
                                    }
                                    else {
                                        new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgCompletedWithFailure"), "info");
                                    }
                                });
                            }
                        });
                    }
                    else {
                        //Ändere alle Leistungskomponenten
                        let questionDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgServiceLevelAgreementServiceCategory.ReallyChangeAllServices"), "question");
                        questionDialog.DialogResult.subscribe((result) => {
                            if (result === true) {
                                Bao.post("ServiceLevelAgreementTab/Change", JSON.stringify({
                                    oldAmount: dialog.Amount(),
                                    oldPrice: dialog.Tarif(),
                                    newAmount: this.SelectedServiceCategoryRow()["Amount"],
                                    newPrice: this.SelectedServiceCategoryRow()["Price"],
                                    serviceCategoryId: this.SelectedServiceCategoryRow()["ServiceCategoryId"],
                                    serviceLevelAgreementId: this.ServiceLevelAgreement.ServiceLevelAgreementId(),
                                    month: dialog.Month(),
                                    year: dialog.Year(),
                                    changeAll: true
                                }), (result) => {
                                    if (result.Result == true) {
                                        new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgCompletedWithSuccess"), "info");
                                    }
                                    else {
                                        new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgCompletedWithFailure"), "info");
                                    }
                                });
                            }
                        });
                    }
                }
            });
        });
    }
    ;
    enableDisableButton(actionKey, enabled) {
    }
    ;
    Refresh() {
        var def = $.Deferred();
        Bao.post("ServiceLevelAgreementTab/ResetServiceLevelAgreementServiceCategory", JSON.stringify({ sessionTabId: this.ServiceLevelAgreement.TabPage.SessionTabId }), () => {
            this.RefreshGrid().then(() => {
                def.resolve();
            });
        });
        return def.promise();
    }
    ;
    Save() {
        return Bao.post("ServiceLevelAgreementTab/SaveServiceLevelAgreementServiceCategory", JSON.stringify({
            sessionTabId: this.ServiceLevelAgreement.TabPage.SessionTabId,
            serviceLevelAgreementId: this.ServiceLevelAgreement.ServiceLevelAgreementId(),
            saveTime: this.ServiceLevelAgreement.SaveTime()
        }));
    }
    ;
    loaded() {
        return this.Refresh();
    }
    ;
}
export default ServiceLevelAgreementServiceCategoryTabModel;